/* eslint-disable camelcase */
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default {
    getSalesforceAccessToken(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('askforemost_ext'), 'getSalesforceAccessToken', [], additionalHeaders);
    }
};